<template>
  <div class="analyzes">
    <div class="d-flex flex-row justify-content-between mt-4 align-items-center">
      <h2 class="d-block">{{$t('nav.analyzes')}}</h2>
      <router-link v-if="settings.dynamic_analyzes_charts"  :to="{name:'profile.analyzes.detail'}" class="w-auto d-block">
        <img style="width: 25px;" src="~@/assets/images/bar-chart.svg" alt="">
      </router-link>
    </div>

        <div v-if="analyzes.length === 0">
          {{ $t('analyzes.not_found') }}
    </div>

    <div class="item row" v-for="analyze in analyzes" :class='{ "read": analyze.read }'>
      <i class="fa fa-check" aria-hidden="true"></i>

      <div class="col-2 d-flex align-items-center justify-content-start">
        {{ formatDate(analyze.date) }}
      </div>

      <div class="col-8 d-flex align-items-center justify-content-start">
        {{ analyze.title }}
      </div>

      <div class="download col-2 d-flex align-items-center justify-content-end">
        <button @click="openAnalyzeModal(analyze)" class="icon__info"></button>
        <span>PDF</span>
      </div>
    </div>

    <b-modal ref="analyzeModal" centered size="lg" hide-footer title="Документ">
      <div class="loading" v-if="selectedAnalyzeContentLoading">
        {{$t('common.loading')}}
      </div>

      <iframe class="content w-100 h-auto" style="min-height: 500px" ref="analyzeContent"></iframe>

      <div class="mt-3">
        <button class="btn-blue mr-1" v-if="selectedAnalyzeContent" @click="downloadAnalyze()">{{$t('buttons.download')}}</button>
        <button class="btn-blue" @click="hideAnalyzeModal()">{{$t('buttons.hide')}}</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import moment from 'moment'
import config from '@/helpers/configDateFormats'
import fileSave from "@/helpers/fileSave";

export default {
  name: 'analyzes',
  data() {
    return {
      selectedAnalyze: null,
      selectedAnalyzeContentLoading: false,
      selectedAnalyzeContent: null,
    };
  },
  computed: mapGetters({
    analyzes: 'analyzes',
    settings:'settings'
  }),
  methods: {
    formatDate(date) {
      return moment(date).format(config.DATE_FORMAT_OUTPUT);
    },
    openAnalyzeModal(analyze) {
      this.selectedAnalyzeContent = null;

      if (this.$refs.analyzeContent) {
        this.$refs.analyzeContent.src = '';
      }

      this.selectedAnalyzeContentLoading = true;

      this.selectedAnalyze = analyze;
      this.$refs.analyzeModal.show();
      this.$store
          .dispatch('getAnalyzeDocument', analyze)
          .then(content => {
            this.selectedAnalyzeContent = content.data;
            this.selectedAnalyzeContentLoading = false;
            let byteCharacters = atob(content.data);
            let byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            let file = new Blob([byteArray], {type: 'application/pdf;base64'});
            this.$refs.analyzeContent.src = URL.createObjectURL(file);
            this.$store
                .dispatch('getAnalyzesList');
          })
    },
    hideAnalyzeModal() {
      this.$refs.analyzeModal.hide();
      this.selectedAnalyzeContent = null;
      this.$refs.analyzeContent.src = '';
    },
    downloadAnalyze() {
      if (this.selectedAnalyzeContent) {
        let byteCharacters = atob(this.selectedAnalyzeContent);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        fileSave({
          blob: byteArray,
          type: 'application/pdf',
          name: this.selectedAnalyze.title,
        });
      }
    },
  },
  mounted() {
    this.$store
        .dispatch('getAnalyzesList');

  },
}
</script>

<style lang="scss">
.analyzes {
  & > h2 {
    font-size: 42px;
    color: #0a4766;
    margin-top: 25px;
  }

  & > .item {
    min-height: 90px;

    &:not(:first-child) {
      border-bottom: 2px solid rgba(163, 190, 204, 0.25);
    }

    & > .download {
      & > *:not(:last-child) {
        margin-right: 10px;
      }
    }

    &:last-child {
      border-bottom: none;
    }
  }

  iframe.content {
    width: 100%;
    min-height: 75vh;
  }
}
</style>
